// extracted by mini-css-extract-plugin
export default {"container":"Instructions_container__7tejV","steps":"Instructions_steps__ZYOqk","stepsAction":"Instructions_stepsAction__TCcVL"};